"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRetry = void 0;
var tslib_1 = require("tslib");
var sleep_1 = require("./sleep");
var IkeRetry = /** @class */ (function () {
    function IkeRetry() {
    }
    /**
     * Retry a function `count` times until it returns true
     *
     * @param fn Function to try to execute
     * @param count max number of times to try
     * @param minDelay Delay between attempts (i * delay)
     */
    IkeRetry.retry = function (fn_1, log_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function (fn, log, count, minDelay) {
            var i, exists, delay;
            if (count === void 0) { count = 3; }
            if (minDelay === void 0) { minDelay = 50; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 1;
                        _a.label = 1;
                    case 1:
                        if (!(i <= count)) return [3 /*break*/, 5];
                        return [4 /*yield*/, fn()];
                    case 2:
                        exists = _a.sent();
                        if (exists) {
                            return [2 /*return*/, true];
                        }
                        delay = minDelay * i;
                        log.info({ attempt: i, maxAttempt: count, delay: delay }, 'RetrySleep');
                        return [4 /*yield*/, sleep_1.IkeSleep.sleep(delay)];
                    case 3:
                        _a.sent(); // 25, 50, 75, 100ms delay
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * Retry a function until it stops throwing a error
     *
     * @param fn Function to try to execute
     * @param count max number of times to try
     * @param minDelay Delay between attempts (i * delay)
     */
    IkeRetry.retryThrowable = function (fn_1, log_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function (fn, log, count, minDelay) {
            var obj, errors;
            var _this = this;
            if (count === void 0) { count = 3; }
            if (minDelay === void 0) { minDelay = 50; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errors = [];
                        return [4 /*yield*/, IkeRetry.retry(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var e_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, fn()];
                                        case 1:
                                            obj = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            e_1 = _a.sent();
                                            log.warn({ error: e_1 }, 'RetryThrowable');
                                            errors.push(e_1);
                                            return [2 /*return*/, false];
                                        case 3: return [2 /*return*/, true];
                                    }
                                });
                            }); }, log, count, minDelay)];
                    case 1:
                        _a.sent();
                        if (obj == null) {
                            throw errors.pop();
                        }
                        return [2 /*return*/, obj];
                }
            });
        });
    };
    return IkeRetry;
}());
exports.IkeRetry = IkeRetry;
//# sourceMappingURL=retry.js.map